import { observer } from "mobx-react-lite"
import { FC, useContext, useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { Context } from "../.."
import styles from "../../styles/Header.module.scss"
import useWindowDimensions from "../../hooks/useWindowDimensions"
import {isNullOrUndefined} from "../../utils"

interface HeaderProps {
  isMobile?: boolean
  onOpenMenu: any
  goToSection: any
  animationToggle: boolean
}

const Header: FC<HeaderProps> = ({
  onOpenMenu, goToSection, isMobile = false, animationToggle = false
}) => {

  const { store, loyaltyStore } = useContext(Context)

  const { width } = useWindowDimensions()
  const location = useLocation()
  
  const [headerToggled, setHeaderToggled] = useState(false);
  const [floatHeaderVisible, setFloatHeaderVisible] = useState(true);

  const [logoAnim, setLogoAnim] = useState(false)

  useEffect(() => {
    if (animationToggle === true) {
      setLogoAnim(true)
    }
  }, [animationToggle]);

  useEffect(() => {
    console.log(location.pathname)
    if (location.pathname !== "/404") {
      store.setPrevLastRoute(`${store.lastRoute}`)
      localStorage.setItem("prev_last_route", `${store.lastRoute}`)
      setTimeout(() => {
        store.setLastRoute(location.pathname)
        localStorage.setItem("last_route", location.pathname)
      }, 300)
    }

    if (location.pathname === "/") {
      store.setXScr(370)
    } else if (location.pathname === "/franchise") {
      store.setXScr(370)
    } else if (width <= 960) {
      store.setXScr(370)
    } else {
      store.setXScr(370)
    }
  }, [location.pathname])

  useEffect(() => {
    let scrFix = 0;

    const lr = localStorage.getItem("last_route")
    const plr = localStorage.getItem("prev_last_route")
    if (lr !== null && plr !== null) {
      store.setLastRoute(lr)
      store.setPrevLastRoute(plr)
    }

    const onScroll = (event: any) => {
      //console.log(event.target.scrollingElement.scrollTop);
      const scrollTop = event.target.scrollTop;
      if (scrollTop >= 20) {
        setHeaderToggled(true)
      } else {
        setHeaderToggled(false)
      }

      console.log(store.xScr)

      if (scrollTop < scrFix && scrollTop < store.xScr) {
        setFloatHeaderVisible(prev => prev = true)
      } else if (scrollTop > store.xScr) {
        setFloatHeaderVisible(prev => prev = false)
      }

      scrFix = scrollTop;
    }
    
    const root = document.getElementById("root")
    root.addEventListener('scroll', onScroll)

    return () => {
      root.removeEventListener('scroll', onScroll)
    }
  }, []);

  return (
    <>
      <header className={styles.header + " " + styles.antiblured + (headerToggled ? " " + styles.fixed : "") + (!floatHeaderVisible ? " " + styles.white : "") + (location.pathname === "/branches" ? " " + styles.psd : "")} style={{
        top: loyaltyStore.isAccTgl ? "-62px" : "0px"
      }}>
        <div className="container">
          <div className="row">
            <div className="row">
              <div className="col-6">
                <div className={styles.logo + (!isNullOrUndefined(store.subscribeData) ? " " + styles.plus : "") + (logoAnim ? " " + styles.animated : "") + (store.userData.is_barber ? " " + styles.brb : "")}>
                  {/* <img className={styles.hapka} src="/assets/images/hapka.webp" /> */}
                  <a href="/"><img src="/assets/images/biglogo.webp" /></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  )
}

export default observer(Header)